import { MainCard } from 'components/CapitalRevamp';
import React from 'react';
import LogoCommonWealth from 'assets/images/backoffice/capital/logo-commonwealth-long.png';
import styles from '../StatusFastLoan.css';

function StatusCommonWealth() {
  return (
    <div className={styles['status-wrapper']}>
      <MainCard border="blue" title="Status Pinjaman Anda">
        <div className={styles['status-content']}>
          <img
            src={LogoCommonWealth}
            className={styles['logo-common-wealth']}
          />
          <p className={styles['status-label']}>On Process</p>
        </div>
      </MainCard>
    </div>
  );
}

export default StatusCommonWealth;
